import { makeStyles } from '@material-ui/core';
import { max, min } from 'date-fns';
import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { useTypedSelector } from '../../../redux';
import { theme } from '../../../theme/theme';
import { Button } from '../../global';
import missingPlan from './NoProjectMissingPlan.svg';
import missingProject from './NoProjectMissingProject.svg';

const useNoProjectClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        color: theme.colors.darkBlue[5],
        '& > span:first-of-type': {
            ...theme.typography.headings.h2,
        },
        '& > span:last-of-type': {
            ...theme.typography.content.text,
        },
    },
});

/**
 * Editor view displayed when there is no project available in the store, or no plan.
 *
 * @param props.onCreatePlan callback triggered when the create plan button is clicked
 * @param props.onStartProject callback triggered when the start project button is clicked
 */
export const NoProject = (props: { onCreatePlan: () => void; onStartProject: () => void }) => {
    const classes = useNoProjectClasses();
    const { t } = usePrefixTranslation('project', { project: 'editor.NoProject' });
    const { asset, plan } = useTypedSelector(state => ({ asset: state.asset.changed, plan: state.plan.changed }));
    const status = plan ? 'planned' : 'not-planned';
    const minDueDate = min([plan?.external_due_date ?? 0, plan?.internal_due_date ?? 0]);
    const maxDueDate = max([plan?.external_due_date ?? 0, plan?.internal_due_date ?? 0]);
    const dueDate =
        plan == undefined
            ? new Date(0)
            : +minDueDate !== 0
            ? maxDueDate > new Date()
                ? minDueDate
                : maxDueDate
            : minDueDate;

    if (!asset) return <span>{'#asset not in store'}</span>;

    return (
        <div className={classes.root}>
            <img src={status === 'not-planned' ? missingPlan : missingProject} alt='no project' />
            <span>{t(`title-${status}`)}</span>
            <span>{t(`subtitle-${status}`, { date: dueDate })}</span>
            <Button variant='contained' onClick={status === 'not-planned' ? props.onCreatePlan : props.onStartProject}>
                {t(`button-${status === 'not-planned' ? 'create-plan' : 'start-project'}`)}
            </Button>
        </div>
    );
};
